import { useEffect, useLayoutEffect, useMemo, useRef } from "react"
import { useThree } from "@react-three/fiber"
import * as THREE from "three"
import { useControls } from "leva"

export default function CameraGradient({ camRef }) {
  const plane = useRef()
  const { viewport } = useThree()

  const vertexShader = `
    varying vec2 vUv;

    void main() {
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      vUv = uv;
    }
  `
  const fragmentShader = `
    varying vec2 vUv;

    void main() {
    float strenght = vUv.y;

    vec3 bottomColor = vec3(1.0);
    vec3 gradientColor = mix(vec3(0.6549, 1.0, 0.8549), vec3(0.85098, 0.55294, 0.96078), vUv.x);

    float t = clamp((strenght - 0.2) / (1.0 - 0.2), 0.0, 1.0);
    float alpha = t ;

    vec3 color = mix(gradientColor,bottomColor, t);

    gl_FragColor = vec4(color, 1.0);
}

  `

  useLayoutEffect(() => {
    if (!camRef.current || !plane.current) return

    camRef.current.add(plane.current)
    plane.current.position.set(0, 0, -10)
    plane.current.scale.set(viewport.width, viewport.height, 1)

    return () => camRef.current.remove(plane.current)
  }, [camRef, viewport])

  return (
    <mesh ref={plane}>
      <planeGeometry args={[1, 1]} />
      <shaderMaterial
        vertexShader={vertexShader}
        fragmentShader={fragmentShader}
        transparent
        toneMapped={false}
        blending={THREE.MultiplyBlending}
        depthTest={false}
        depthWrite={false}
      />
    </mesh>
  )
}
